import { createFileRoute } from '@tanstack/react-router';

import { TechnologicalTransferSearchClaimable } from '@/module/Author/TechnologicalTransfer/TechnologicalTransferSearchClaimable';

export const Route = createFileRoute(
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/search-claimable',
)({
  component: TechnologicalTransferSearchClaimable,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});
